module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), (!_vm.userHasAccess) ? _c('div', [_c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.membershipStatusDisplayValues.spanText) + "\n        "), (_vm.user.membership_status === 'UNPAID' || _vm.user.membership_status === 'PAST_DUE') ? _c('span', [_c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or\n        ")], 1) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": _vm.membershipStatusDisplayValues.emailHref
    }
  }, [_vm._v("\n        contact our billing team.\n      ")])])], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "no-underline mv4 db",
    attrs: {
      "to": "/add-device-category"
    }
  }, [_c('div', {
    staticClass: "color-theme"
  }, [_vm._v("← View all categories")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-fourth mt4",
    class: [!_vm.userHasAccess ? 'pb5' : '']
  }, [_c('div', [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemTypeIndex),
      expression: "itemTypeIndex"
    }],
    staticClass: "b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "device_type",
      "type": "text"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.itemTypeIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeType]
    }
  }, [_c('option', {
    domProps: {
      "value": -1
    }
  }, [_vm._v("Select a type of item")]), _vm._v(" "), _vm._l((_vm.itemTypes), function(type, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v("\n          " + _vm._s(type.name) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('div', [_vm._m(2), _vm._v(" "), (_vm.itemMakes.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemMakeIndex),
      expression: "itemMakeIndex"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "brand"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.itemMakeIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeMake]
    }
  }, [_c('option', {
    staticClass: "placeholder",
    domProps: {
      "value": -1
    }
  }, [_vm._v("Select a brand")]), _vm._v(" "), _vm._l((_vm.itemMakes), function(make, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(make.name))])
  }), _vm._v(" "), (_vm.itemTypeName !== 'Phone') ? _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")]) : _vm._e()], 2) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemMakeString),
      expression: "itemMakeString"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "brand",
      "type": "text"
    },
    domProps: {
      "value": (_vm.itemMakeString)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemMakeString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._m(3), _vm._v(" "), (_vm.itemModels.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModelIndex),
      expression: "itemModelIndex"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "model"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.itemModelIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeModel]
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Select a model")]), _vm._v(" "), _vm._l((_vm.itemModels), function(model, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(model.name) + "\n        ")])
  }), _vm._v(" "), (_vm.itemTypeName !== 'Phone') ? _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")]) : _vm._e()], 2) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModelString),
      expression: "itemModelString"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "model",
      "type": "text"
    },
    domProps: {
      "value": (_vm.itemModelString)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemModelString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.price),
      expression: "price",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "flex-grow br5-box-left input-reset ba br--left b--black-20 pa2 br1 tr",
    attrs: {
      "id": "price",
      "type": "number"
    },
    domProps: {
      "value": (_vm.price)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.price = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center inter br5-box-right bg-black-10 pa2"
  }, [_vm._v(".00")])])]), _vm._v(" "), (this.device_type === 'laptop') ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "model_number"
    }
  }, [_vm._v("Model\n        " + _vm._s(_vm.itemMakeName === 'Apple' ? 'Year' : 'Number'))]), _vm._v(" "), (_vm.brand === 'Apple' && _vm.device_type === 'laptop') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model_number),
      expression: "model_number"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    class: _vm.model_number === '' ? 'placeholder' : '',
    attrs: {
      "id": "model_number"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model_number = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "placeholder",
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a year")]), _vm._v(" "), _vm._l((_vm.available_years), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model_number),
      expression: "model_number"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "model_number",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model_number)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model_number = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), ((this.device_type === 'laptop' || this.device_type === 'tablet' || this.device_type === 'tv')) ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "screen_size"
    }
  }, [_vm._v("Screen Size")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.screen_size),
      expression: "screen_size",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "flex-grow input-reset br5-box-left ba br--left b--black-20 pa2 mb2 br1 tr",
    attrs: {
      "id": "screen_size",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.screen_size)
    },
    on: {
      "blur": [function($event) {
        return _vm.toggleKeyboard(false)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.screen_size = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center inter br5-box-right bg-black-10 pa2 mb2"
  }, [_vm._v("in.")])])]) : _vm._e(), _vm._v(" "), (this.device_type === 'laptop' || this.device_type === 'phone') ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "storage"
    }
  }, [_vm._v("Storage")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.storage),
      expression: "storage",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "flex-grow input-reset br5-box-left ba br--left b--black-20 w-60 pa2 mb2 br1 tr",
    attrs: {
      "id": "storage",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.storage)
    },
    on: {
      "blur": [function($event) {
        return _vm.toggleKeyboard(false)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.storage = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center inter br5-box-right bg-black-10 pa2 mb2"
  }, [_vm._v("GB")])])]) : _vm._e(), _vm._v(" "), (this.device_type === 'phone') ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "carrier"
    }
  }, [_vm._v("Carrier")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carrier),
      expression: "carrier"
    }],
    staticClass: "b--black-20 pa2 mb2 db w-100 br1",
    class: _vm.carrier === '' ? 'placeholder' : '',
    attrs: {
      "id": "carrier"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carrier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a carrier")]), _vm._v(" "), _vm._l((_vm.mobileOperators), function(carrier, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": carrier.id
      }
    }, [_vm._v(_vm._s(carrier.name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (this.device_type === 'phone' && _vm.isOtherMobileCarrierSelected) ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "storage"
    }
  }, [_vm._v("Other Carrier")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device_carrier_other),
      expression: "device_carrier_other"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "device_carrier_other",
      "type": "text"
    },
    domProps: {
      "value": (_vm.device_carrier_other)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.device_carrier_other = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (this.device_type === 'phone') ? _c('div', [_c('fieldset', {
    staticClass: "input-reset bn pa0 ma0"
  }, [_c('legend', {
    staticClass: "inter f6 b db mb2"
  }, [_vm._v("Do you pay in installments")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-around"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installments),
      expression: "installments"
    }],
    staticClass: "dn",
    attrs: {
      "id": "installments1",
      "name": "installments",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.installments, true)
    },
    on: {
      "change": function($event) {
        _vm.installments = true
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 inter b br-0 ba tc br5-box-left br--left b--grey silver bg-white pointer",
    attrs: {
      "for": "installments1",
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.installments = true
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installments),
      expression: "installments"
    }],
    staticClass: "dn",
    attrs: {
      "id": "installments2",
      "name": "installments",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.installments, false)
    },
    on: {
      "change": function($event) {
        _vm.installments = false
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 inter bl-0 b ba tc br5-box-right br--right b--grey silver bg-white pointer",
    attrs: {
      "for": "installments2",
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.installments = false
      }
    }
  }, [_vm._v("No")])])])]) : _vm._e(), _vm._v(" "), (this.device_type === 'laptop' || this.device_type === 'tv') ? _c('div', [_c('fieldset', {
    staticClass: "input-reset bn pa0 ma0"
  }, [_c('legend', {
    staticClass: "f6 inter b db mb2"
  }, [_vm._v("\n          " + _vm._s(this.device_type === 'tv' ? 'Is it a smart TV' : 'Is it touchscreen') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-around"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.touchscreen),
      expression: "touchscreen"
    }],
    staticClass: "dn",
    attrs: {
      "id": "touchscreen1",
      "name": "touchscreen",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.touchscreen, true)
    },
    on: {
      "change": function($event) {
        _vm.touchscreen = true
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba br-0 br5-box-left b--grey silver bg-white pointer",
    attrs: {
      "for": "touchscreen1",
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.touchscreen = true
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.touchscreen),
      expression: "touchscreen"
    }],
    staticClass: "dn",
    attrs: {
      "id": "touchscreen2",
      "name": "touchscreen",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.touchscreen, false)
    },
    on: {
      "change": function($event) {
        _vm.touchscreen = false
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba bl-0 br5-box-right b--grey silver bg-white pointer",
    attrs: {
      "for": "touchscreen2",
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.touchscreen = false
      }
    }
  }, [_vm._v("No")])])])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition),
      expression: "condition"
    }],
    staticClass: "b--black-20 pa2 mb2 db w-100 br1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.condition = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.itemPurchaseConditions), function(condition, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": condition.id
      }
    }, [_vm._v("\n        " + _vm._s(condition.description) + "\n      ")])
  }), 0)]), _vm._v(" "), _c('div', [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchased_at),
      expression: "purchased_at"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "purchased_at",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchased_at)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.purchased_at = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase_date),
      expression: "purchase_date"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "purchase_date",
      "max": _vm.todayString,
      "type": "date"
    },
    domProps: {
      "value": (_vm.purchase_date)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.purchase_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "serial_number"
    }
  }, [_vm._v("Serial Number"), (_vm.device_type === 'tablet' || _vm.device_type === 'phone' || _vm.device_type === 'laptop') ? _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serial_number),
      expression: "serial_number"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "serial_number",
      "type": "text"
    },
    domProps: {
      "value": (_vm.serial_number)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serial_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.device_type === 'phone') ? _c('a', {
    staticClass: "red inter f7 no-underline",
    attrs: {
      "href": "https://help.getakko.com/en/articles/4641960-how-to-find-my-serial-number-on-an-iphone-samsung-or-google-phone",
      "target": "_blank"
    }
  }, [_vm._v("Click\n        here to find your serial number")]) : _vm._e()]), _vm._v(" "), (_vm.device_type === 'phone') ? _c('div', [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imei),
      expression: "imei"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "imei",
      "maxlength": "16",
      "type": "text"
    },
    domProps: {
      "value": (_vm.imei)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imei = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.device_type === 'phone') ? _c('a', {
    staticClass: "red inter f7 no-underline",
    attrs: {
      "href": "https://help.getakko.com/en/articles/6082165-how-to-find-my-imei-number-on-an-iphone-samsung-or-google-phone",
      "target": "_blank"
    }
  }, [_vm._v("Click\n        here to find your IMEI number")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nickname),
      expression: "nickname"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "nickname",
      "type": "text"
    },
    domProps: {
      "value": (_vm.nickname)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickname = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.$store.state.errors.length) ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$store.state.errors[0]))])]) : _vm._e(), _vm._v(" "), (_vm.userHasAccess) ? _c('div', {
    staticClass: "mt4 mb5 mw5-ns"
  }, [_c('ak-button', {
    class: _vm.submitBtnClass,
    attrs: {
      "disabled": !_vm.formComplete,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDevice.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Add Item\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.errorDetected) ? _c('ak-modal', {
    attrs: {
      "title": "Unable to Add Device to Account"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mb4"
  }, [_vm._v(_vm._s(_vm.restrictionLimitReachedMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex-ns flex-wrap justify-end",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-end"
  }, [_c('span', {
    staticClass: "f2 b title-responsive"
  }, [_vm._v("Add new item")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "device_type"
    }
  }, [_vm._v("Item"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "brand"
    }
  }, [_vm._v("Brand"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "model"
    }
  }, [_vm._v("Model"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Purchase price"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter"
  }, [_vm._v("Condition when purchased"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("Where was it purchased?"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("When was it purchased?"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "imei"
    }
  }, [_vm._v("IMEI"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("Nickname"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-baecd688", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baecd688","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddDeviceV2.vue
// module id = 1482
// module chunks = 0